<template>
  <b-form-input
    ref="inputRef"
    :placeholder="placeholder"
    @keydown.enter.prevent
    @keyup="$root.$emit('updateSameDeliverNow')">
  </b-form-input>
</template>

<script>
import { useCurrencyInput } from 'vue-currency-input';

export default {
  name: 'CurrencyInput',
  props: {
    value: Number, // Vue 2: value
    options: Object,
    placeholder: String
  },
  setup(props) {
    const { inputRef } = useCurrencyInput(props.options)

    return { inputRef }
  }
}
</script>
